import mapKnownValues from "@/utils/mapKnownValues";
import { ClusterTree } from "@/classes/cluster";
import { ItemStatusType } from "@/classes/itemStatusType";

export type PanelAPIResponse = {
  id: string;
  name: string;
  description: string;
  maxAmps: number;
  parentId: string | null;
  pKey: string;
  createdAt: string; // date
  itemStatus: ItemStatusType;
};

export default class Panel {
  id = "";
  name = "";
  description = "";
  maxAmps = 0;
  parentId: null | string = null;
  pKey = "";
  createdAt = new Date(); // readonly from backend
  itemStatus: ItemStatusType = ItemStatusType.ACTIVE; // readonly from backend

  constructor(params: Partial<Panel> = {}) {
    mapKnownValues(this, params);
  }
}

export class PanelTree {
  panel = new Panel();
  panels: PanelTree[] = [];
  clusters: ClusterTree[] = [];

  constructor(params: Partial<PanelTree>) {
    mapKnownValues(this, params);
  }
}
